import React from 'react';
import {Tbody} from './style';

const DataTbody = (props) => {
  return (
    <Tbody style={props.style}>
      {props.children}
    </Tbody>
  )
}

export default DataTbody;